/*
 *
 * OperationCurrency
 *
 * @version 1.0.0
 * @author Andrea Esposito
 * @since 26-May-2026
 */

import React from 'react'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  operationamount: <PortalMessage id='t.app.orders.operation.currency.operationAmount' defaultMessage='Operation Amount' />,
  merchantamount: <PortalMessage id='t.app.orders.operation.currency.merchantAmount' defaultMessage='Captured Amount' />,
  conversionrate: <PortalMessage id='t.app.orders.operation.currency.conversionRate' defaultMessage='Conversion Rate' />,
  conversionratedate: <PortalMessage id='t.app.orders.operation.currency.conversionRateDate' defaultMessage='Conversion Rate Date' />,
}

export default formattedMessage
